/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {DocumentNode} from '@apollo/client';
import DropDownInput from '../../components/DropDownInput';
import GqlQueryController from '../GqlQueryController/GqlQueryController';
import {DropDownItem} from 'components/DropDownInput/DropDownInput';

interface DropDownControllerProps {
  query: DocumentNode;
  queryVariables?: Record<string, any>;
  rootField: string;
  transformResult: (item: any) => {
    key: string;
    description: string;
  };
  placeholder?: string;
  label?: string;
  onChange?: (item: DropDownItem | null) => void;
  value?: string;
  defaultOption?: DropDownItem;
}

const DropDownController: React.FC<DropDownControllerProps> = ({
  query,
  queryVariables = {},
  rootField,
  transformResult,
  placeholder,
  label,
  onChange,
  value,
  defaultOption,
}) => {
  const [options, setOptions] = React.useState<DropDownItem[]>([]);
  console.log('default option', defaultOption);
  return (
    <GqlQueryController
      QUERY={query}
      variables={queryVariables}
      rootField={rootField}
      initialState={[]}
      onSuccess={(data: any[]) => {
        const result: DropDownItem[] = defaultOption
          ? [defaultOption, ...(data.map(transformResult) as DropDownItem[])]
          : [...(data.map(transformResult) as DropDownItem[])];
        setOptions(result);
      }}
    >
      {() => (
        <DropDownInput
          children={options}
          noSelection=""
          value={value}
          sx={{background: 'white'}}
          onChange={event => {
            const id = event.target.value;
            const selected = options.find(option => option.key === id) || null;
            if (onChange) {
              onChange(selected);
            }
          }}
          placeholder={placeholder}
          label={label}
        />
      )}
    </GqlQueryController>
  );
};

export default DropDownController;
